import { styled } from '@obvio/app'
import { SvgHalfLogo } from '@obvio/svg'
import GoogleMapReact from 'google-maps-react-markers'

import { MAP_STYLE } from '../JuraMapStyles'
import { MarkerNode } from '../Map/Marker'

import type { ReactElement } from 'react'

const MapWrap = styled.div`
  padding: 0 !important;
  height: 100%;
  width: 100vw;
  position: relative;
`

const Logo = styled(SvgHalfLogo)`
  top: -2.5rem;
  position: absolute;
  color: #8c8a7c;
`

export function Map511(): ReactElement {
  return (
    <MapWrap>
      <GoogleMapReact
        apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API}
        defaultCenter={{ lat: 50.4507, lng: 19.552 }}
        defaultZoom={9.5}
        options={{
          styles: MAP_STYLE,
          disableDefaultUI: true,
          draggable: false,
        }}
      >
        {/** @ts-expect-error */}
        <MarkerNode lat={50.4507} lng={19.552}>
          <Logo />
        </MarkerNode>
      </GoogleMapReact>
    </MapWrap>
  )
}
